<template>
  <div class="fc-button">
    <div class="background"></div>
    <div>
      <span>{{this.text}}</span>
      <img src="@/assets/icons/cta-arrow.svg" alt />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.fc-button {
  cursor: pointer;
  position: relative;
  display: inline-block;
  border: 3px solid #ffffff;
  box-shadow: 0px 0px 15px 0px $accent-color;
  box-sizing: border-box;
  .background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-repeat: no-repeat;
    padding: 0;
    background: $secondary-color;
  }
  div {
    font-size: 32px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    position: relative;
    padding: 22px 36px;
    font-weight: bold;
  }
  img {
    margin-right: 10px;
    float: right;
  }
}
</style>